import { render, staticRenderFns } from "./PortfolioFive.vue?vue&type=template&id=5bd89a02&"
import script from "./PortfolioFive.vue?vue&type=script&lang=js&"
export * from "./PortfolioFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports